<template>
  <div class="d-flex justify-center align-center flex-column">
    <property-form
      :value="
        value ||
        Object.keys(fields).reduce((a, v) => {
          a[v] = fields[v].default ?? '';
          return a;
        }, {})
      "
      :fields="fields"
      @input="createCourse"
    />
    <error-message-wrapper ref="error_wrapper" />
  </div>
</template>

<script>
import PropertyForm from "@/components/PropertyForm";
import ErrorMessageWrapper from "./ErrorMessageWrapper.vue";

export default {
  name: "B2C_Form",
  components: { PropertyForm, ErrorMessageWrapper },
  data() {
    return {
      phoneRules: [
        (v) =>
          !v ||
          /^\+\d{1} \(\d{3}\) \d{3} \d{2} \d{2}$/.test(v) ||
          "Пример: +7 (999) 111 22 33",
      ],
      emailRules: [
        (v) => (!!v && !v.includes(" ")) || "Обязательное поле без пробелов",
        (v) => /.+@.+\..+/.test(v) || "Пример: abc@de.fg",
      ],
      nameRules: [(v) => !!v || "Обязательное поле"],
      ageRules: [
        (v) => !!v || "Обязательное поле",
        (v) => /^\d+$/.test(v) || "Можно использовать только целые числа",
      ],
    };
  },

  computed: {
    value() {
      return this.modalFormComponent?.value;
    },
    fields() {
      return {
        email: {
          label: "E-Mail (login)",
          visible: true,
          default: "",
          rules: this.emailRules,
        },
        name: {
          label: "Имя",
          visible: true,
          default: "",
          rules: this.nameRules,
        },
        phone: {
          label: "Телефон",
          visible: true,
          default: "",
          rules: this.phoneRules,
        },
        age: {
          label: "Возраст",
          visible: true,
          default: "",
          rules: this.ageRules,
        },
      };
    },
  },
  methods: {
    createCourse: async function (value) {
      this.$emit("confirm", value);
    },
  },
};
</script>

<style scoped lang="scss" />
